/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { HarmonyOnePunksMarket } from "../HarmonyOnePunksMarket";

export class HarmonyOnePunksMarket__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    harmonyOnePunksAddress: string,
    royalty: BigNumberish,
    overrides?: Overrides
  ): Promise<HarmonyOnePunksMarket> {
    return super.deploy(
      harmonyOnePunksAddress,
      royalty,
      overrides || {}
    ) as Promise<HarmonyOnePunksMarket>;
  }
  getDeployTransaction(
    harmonyOnePunksAddress: string,
    royalty: BigNumberish,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      harmonyOnePunksAddress,
      royalty,
      overrides || {}
    );
  }
  attach(address: string): HarmonyOnePunksMarket {
    return super.attach(address) as HarmonyOnePunksMarket;
  }
  connect(signer: Signer): HarmonyOnePunksMarket__factory {
    return super.connect(signer) as HarmonyOnePunksMarket__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HarmonyOnePunksMarket {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as HarmonyOnePunksMarket;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "harmonyOnePunksAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royalty",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ListingCancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "seller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "ListingCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "seller",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "Sale",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "buy",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "cancelListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "createListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "buyer",
        type: "address",
      },
    ],
    name: "createPrivateListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getListing",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "masterAddress",
        type: "address",
      },
    ],
    name: "setMasterAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "royalty",
        type: "uint256",
      },
    ],
    name: "setRoyalty",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

const _bytecode =
  "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";
